module.exports = __webpack_public_path__ + "media/img/super-venue/badge-venue-supervenue-5b14b5a1c75c5e02533e2ad466ae33ad.svg";